import React, { useState } from "react";
import "../../app/App.css";
import { toPersianNum, toEnglishNum } from "../../assets/utils";
import {
  ModalContainer,
  ModalText,
  ConfirmBtn,
  CancelBtn,
  BtnContainer,
  PickerContainer,
  Picker,
  PickerTop,
  PickerMain,
  PickerBottom,
} from "./clock.styles";
import NumberPicker from "../../components/numberPicker/numberPicker.component";
import { Modal, Button } from "antd";
const Clock = ({ visible, setVisible }) => {
  const [time, setTime] = useState();
  const [amount, setAmount] = useState();
  const [pickerSelectedAmount, setPickerSelectedAmount] = useState();
  const [pickerSelectedAmount2, setPickerSelectedAmount2] = useState();
  const [pickerAmountState, setPickerAmountState] = useState(1);
  const [pickerAmountState2, setPickerAmountState2] = useState(1);
//   const date = new Date();
//   setTime(date)
  const PickerAmountsArray = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    "00",
  ];
  const PickerAmountsArray2 = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  ];
  const handleCancel = () => {
    setVisible(false);
  };
  const handleUpAmount = () => {
    if (pickerAmountState < 23) {
      setPickerAmountState(pickerAmountState + 1);
      setPickerSelectedAmount(PickerAmountsArray[pickerAmountState + 1]);
    }
  };
  const handleDownAmount = () => {
    if (pickerAmountState > 0) {
      setPickerAmountState(pickerAmountState - 1);
      setPickerSelectedAmount(PickerAmountsArray[pickerAmountState - 1]);
    }
  };
  const handleUpAmount2 = () => {
    if (pickerAmountState2 < 58) {
      setPickerAmountState2(pickerAmountState2 + 1);
      setPickerSelectedAmount2(PickerAmountsArray2[pickerAmountState2 + 1]);
    }
  };
  const handleDownAmount2 = () => {
    if (pickerAmountState2 > 0) {
      setPickerAmountState2(pickerAmountState2 - 1);
      setPickerSelectedAmount2(PickerAmountsArray2[pickerAmountState2 - 1]);
    }
  };
  return (
    <div>
      <Modal
        footer={null}
        closable={false}
        visible={visible}
        onCancel={handleCancel}
      >
        {/* <ModalText>{toPersianNum(time)}</ModalText> */}

        <Picker>
          <PickerContainer>
            <PickerTop onClick={handleDownAmount2}>
              {pickerAmountState2 > 0
                ? toPersianNum(PickerAmountsArray2[pickerAmountState2 - 1])
                : ""}
            </PickerTop>
            <PickerMain>
              {toPersianNum(PickerAmountsArray2[pickerAmountState2])}
            </PickerMain>
            <PickerBottom onClick={handleUpAmount2}>
              {pickerAmountState2 < 58
                ? toPersianNum(PickerAmountsArray2[pickerAmountState2 + 1])
                : ""}
            </PickerBottom>
          </PickerContainer>

          <PickerContainer>
            <PickerTop onClick={handleDownAmount}>
              {pickerAmountState > 0
                ? toPersianNum(PickerAmountsArray[pickerAmountState - 1])
                : ""}
            </PickerTop>
            <PickerMain>
              {toPersianNum(PickerAmountsArray[pickerAmountState])}
            </PickerMain>
            <PickerBottom onClick={handleUpAmount}>
              {pickerAmountState < 23
                ? toPersianNum(PickerAmountsArray[pickerAmountState + 1])
                : ""}
            </PickerBottom>
          </PickerContainer>
        </Picker>

        <BtnContainer>
          <CancelBtn onClick={handleCancel}>لغو</CancelBtn>
          <ConfirmBtn>تایید</ConfirmBtn>
        </BtnContainer>
      </Modal>
    </div>
  );
};

export default Clock;
